import { render, staticRenderFns } from "./feeReceiptsDetailQuery.vue?vue&type=template&id=2c30baf4&"
import script from "./feeReceiptsDetailQuery.vue?vue&type=script&lang=js&"
export * from "./feeReceiptsDetailQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports